import { Controller } from "@hotwired/stimulus"
import { createTimeline, spring } from "animejs"

// Connects to data-controller="components--confirm-message"
export default class extends Controller {
  static targets = [
    "backdrop",
    "modal",
  ]

  connect() {
    this.animate()
  }

  animate() {
    let timeline = createTimeline({
      loop: false,
      onBegin: () => {
        this.element.classList.remove("hidden")
      }
    })

    timeline
      .add(this.modalTarget, {
        scale: [0.8, 1],
        opacity: [0, 1],
        ease: spring({
          bounce: 0.5,
          duration: 400
        })
      }, 0)
      .add(this.backdropTarget, {
        opacity: [0, 1],
        duration: 200,
        easing: "linear"
      }, 0)

    timeline.play()
  }
}
